import { ConfigDataInterface } from './ConfigApiInterface';
import { Config_Person_PageMenu_ApiEnum } from './PersonDetailConfigApiInterface';

export enum Config_PlayerDetail_ActionsMenu_ApiEnum {
    'archive' = 'archive',
}

export enum Config_PlayerDetail_Modules_ApiEnum {
    'indications' = 'indications',
    'overview' = 'overview',
    'matches' = 'matches',
    'passport' = 'passport',
}

export enum Config_PlayerDetail_ActionsOther_ApiEnum {
    'upload_photo' = 'upload_photo',
    'export_passport' = 'export_passport',
}

export enum Config_PlayerDetail_PageSubMenu_ApiEnum {
    'NOTHING' = 'NOTHING',
}

export interface Config_PlayerDetail_ApiInterface
    extends ConfigDataInterface<
        Config_PlayerDetail_Modules_ApiEnum,
        Config_PlayerDetail_ActionsMenu_ApiEnum,
        Config_PlayerDetail_ActionsOther_ApiEnum,
        Config_Person_PageMenu_ApiEnum,
        Config_PlayerDetail_PageSubMenu_ApiEnum
    > {
    _?: boolean;
}
